import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';

export const Footer = () => {
    return (
        <footer className="footer-wrapper text-sm bg-theme2 text-theme4">
            <div className="container-xl py-5">
                <Row className="gx-3 gy-4">
                    <Col md={12} lg={4}>
                        <div className="wrapper text-center text-md-start mx-auto mx-md-0" style={{ maxWidth: '380px' }}>
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Let's Work Together</div>
                            <div className="description text-sm mb-3">
                                Let’s collaborate to empower learners through meaningful Language learning.
                                Yoospeak combines smart technology with expert teaching for real progress.
                                Our vision is to build a global community of confident communicators.
                            </div>
                            <div className="social-sec d-flex align-items-center justify-content-center justify-content-md-start gap-3 mb-2">
                                <Link to={"https://www.facebook.com/@kridemy?lang=en"} target='_blank'><img src={require('../assets/images/facebook.png')} className="img-fluid" alt="Facebook" /></Link>
                                <Link to={"https://www.instagram.com/"} target='_blank'><img src={require('../assets/images/instagram.png')} className="img-fluid" alt="Instagram" /></Link>
                                <Link to={"https://www.linkedin.com/company/"} target='_blank'><img src={require('../assets/images/linkedin.png')} className="img-fluid" alt="Linkedin" /></Link>
                                <Link to={"https://www.reddit.com/"} target='_blank'><img src={require('../assets/images/reddit.png')} className="img-fluid" alt="Reddit" /></Link>
                            </div>
                        </div>
                    </Col>
                    <Col md={3} lg={2}>
                        <div className="wrapper text-center text-md-start">
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Quick Links</div>
                            <ul className="nav flex-column gap-2">
                                <li className="nav-item"><Link to={'/'} className="nav-link">Home</Link></li>
                                <li className="nav-item"><Link to={'/about'} className="nav-link">About Us</Link></li>
                                <li className="nav-item"><Link to={'/contact'} className="nav-link">Contact Us</Link></li>
                                <li className="nav-item"><Link to={'/terms-of-service'} className="nav-link">Terms of Service</Link></li>
                                <li className="nav-item"><Link to={'/privacy-policy'} className="nav-link">Privacy Policy</Link></li>
                                <li className="nav-item"><Link to={'/refund-policy'} className="nav-link">Refund Policy</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={3} lg={2}>
                        <div className="wrapper text-center text-md-start">
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Explore</div>
                            <ul className="nav flex-column gap-2">
                                <li className="nav-item"><Link to={'#'} className="nav-link">FAQ</Link></li>
                                <li className="nav-item"><Link to={'/careers'} className="nav-link">Careers</Link></li>
                                <li className="nav-item"><Link to={'#'} className="nav-link">Cources</Link></li>
                                <li className="nav-item"><Link to={'#'} className="nav-link">Our Services</Link></li>
                                <li className="nav-item"><Link to={'#'} className="nav-link">Teachers</Link></li>
                                <li className="nav-item"><Link to={'#'} className="nav-link">Gallery</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={6} lg={4}>
                        <div className="wrapper text-center text-md-start mx-auto mx-md-0" style={{ maxWidth: '450px' }}>
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Our Newsletter</div>
                            <Form className="mb-4">
                                <Form.Group>
                                    {/* <Form.Label controlId="subscribe">Subscribe Now</Form.Label> */}
                                    <InputGroup>
                                        <Form.Control type="email" className="shadow-none" placeholder="Write your email here.." required />
                                        <Button variant="primary" size='lg'>Subscribe</Button>
                                    </InputGroup>
                                </Form.Group>
                            </Form>
                            <div className="contact-number mb-2">
                                <Link to={'tel:+1 1234567890'} className="d-inline-flex align-items-center gap-2 text-theme4 text-decoration-none">
                                    <i className="bi bi-telephone-fill text-base text-primary lh-1"></i> +1 1234567890
                                </Link>
                            </div>
                            <div className="contact-email mb-2">
                                <Link to={'mailto:ruchika123@gmail.com'} className="d-inline-flex align-items-center gap-2 text-theme4 text-decoration-none">
                                    <i className="bi bi-envelope-fill text-base text-primary lh-1"></i> ruchika123@gmail.com
                                </Link>
                            </div>
                            <div className="contact-address d-inline-flex align-items-center gap-2">
                                <i className="bi bi-geo-alt-fill text-base text-primary lh-1"></i> New Brunswick, New Jersey, USA
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="copyright-sec bg-theme1 py-3">
                <div className="container">
                    <div className="copyright-wrapper text-sm fw-medium text-center text-light">
                        <div className="copyright-text">© Yoospeak 2025. All rights reserved.</div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

